module.exports = __webpack_public_path__ + "img/ResumeTemp6.020beb2b.png";